import React from 'react';

import { useResource } from 'react-resource-router';

import Spinner from '@atlaskit/spinner';

import { NotFoundState } from 'src/components/error-page/components/not-found-state';
import { GlobalError } from 'src/connect/shared/global-error';
import { useIntl } from 'src/hooks/intl';
import { BBError } from 'src/redux/pull-request/api';
import { Loading } from 'src/sections/global/components/loading.style';

import { CommitPage } from './components/commit-page';
import messages from './components/commit-page.i18n';
import { loadCommitResource } from './resources/load-commit-resource';

const CommitRoute = (): JSX.Element => {
  const { data: commit, loading, error } = useResource(loadCommitResource);
  const intl = useIntl();

  if (error instanceof BBError && error.status === 404) {
    return <NotFoundState title={intl.formatMessage(messages.notfound)} />;
  } else if (error) {
    return <GlobalError />;
  }

  if (!commit || loading) {
    return (
      <Loading>
        <Spinner size="large" />
      </Loading>
    );
  }
  return <CommitPage commit={commit} />;
};

export default CommitRoute;
